/** Presentation only: preserve unknown/editorial labels without renumbering rows. */
export const formatLedgerCitation = (label: string): string => {
  const match = /^([A-Za-z]+)[.-]\s*(\d+)$/.exec(label)
  return match ? `${match[1]}. ${match[2].padStart(3, '0')}` : label
}
